import { createFileRoute } from '@tanstack/react-router';

import { CapacityDetailView } from 'src/sections/admin/white-glove/capacity-detail-view';

/**
 * Capacity in detail (WG-65, WG-112): throughput per producer and the at-risk
 * list behind the queue's own summary.
 */
export const Route = createFileRoute('/admin-skidog/capacity')({
  component: AdminCapacityPage,
});

function AdminCapacityPage() {
  return <CapacityDetailView />;
}
